import React from "react";
import PropTypes from "prop-types";

export default function MagniFyingGlass(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.7643 25.7254H27.333C26.4455 25.7254 25.7251 26.4458 25.7251 27.3333V46.6274C25.7251 47.5149 26.4455 48.2353 27.333 48.2353H33.7643C34.6519 48.2353 35.3722 47.5149 35.3722 46.6274V27.3333C35.3722 26.4458 34.6519 25.7254 33.7643 25.7254Z"
        fill={props.fill}
      />
      <path
        d="M20.9018 35.3724H14.4704C13.5829 35.3724 12.8626 36.0928 12.8626 36.9803V46.6274C12.8626 47.5149 13.5829 48.2353 14.4704 48.2353H20.9018C21.7893 48.2353 22.5097 47.5149 22.5097 46.6274V36.9803C22.5095 36.0928 21.7893 35.3724 20.9018 35.3724Z"
        fill={props.fill}
      />
      <path
        d="M46.6269 16.0783H40.1955C39.308 16.0783 38.5877 16.7987 38.5877 17.6862V46.6274C38.5877 47.5149 39.308 48.2353 40.1955 48.2353H46.6269C47.5144 48.2353 48.2348 47.5149 48.2348 46.6274V17.6862C48.2348 16.7987 47.5144 16.0783 46.6269 16.0783Z"
        fill={props.fill}
      />
      <path
        d="M83.0462 78.5L57.0393 52.4928C61.5798 46.9489 64.3131 39.868 64.3131 32.1568C64.3131 14.4255 49.8877 0 32.1566 0C14.4255 0 0 14.4255 0 32.1568C0 49.8881 14.4254 64.3136 32.1565 64.3136C39.8675 64.3136 46.9484 61.5803 52.4922 57.0397L83.0462 87.5939C83.0462 85.5 83.0462 82 83.0462 78.5ZM32.1565 57.8824C17.9723 57.8824 6.4312 46.3413 6.4312 32.1568C6.4312 17.9723 17.9723 6.43127 32.1565 6.43127C46.3406 6.43127 57.8817 17.9725 57.8817 32.1568C57.8817 46.3412 46.3408 57.8824 32.1565 57.8824Z"
        fill={props.fill}
      />
    </svg>
  );
}

MagniFyingGlass.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
MagniFyingGlass.defaultProps = {
  className: "",
  fill: "#E9F1FE",
  width: 84,
  height: 88
};
